module.exports = __webpack_public_path__ + "img/checkbox-mark.a47ee96e.svg";